import { useSyncExternalStore } from "react";
const narrowQuery = "(max-width: 1200px)",
  yieldQuery = "(min-width: 1024px) and (max-width: 1380px)";
function useMedia(query: string) {
  return useSyncExternalStore(
    (listener) => {
      const media = window.matchMedia?.(query);
      media?.addEventListener("change", listener);
      return () => media?.removeEventListener("change", listener);
    },
    () => window.matchMedia?.(query).matches ?? false,
    () => false,
  );
}
export function useQuoteChatLayout() {
  return { narrow: useMedia(narrowQuery), yieldLeft: useMedia(yieldQuery) };
}
